import { uiRows } from './types-def.js';
/** `web/shell` (1.I-1): the shell's rows moved to `web/nav`; further rows arrive by CS rounds. */
export const SHELL_INTERACTIONS = uiRows([]);
//# sourceMappingURL=shell.js.map